import ArticleAuthBanner from '../component/article-auth-banner/ArticleAuthBanner';
import { useAuthGating } from '~/modules/root/hook/use-auth-gating';
import { useAuth } from '~/modules/root/context';
import { useRef } from 'react';
import { useImpression, useTracker } from '@archipro-website/tracker';

export const useArticleGating = () => {
    const { enabled: articleGatingEnabled } = useAuthGating('article-gating');

    const { showAuthModal } = useAuth();
    const bannerRef = useRef(null);
    const tracking = useTracker();

    useImpression({
        ref: bannerRef,
        onImpression: async (url: URL) => {
            tracking.log('ArticleAuthBannerView', {
                url: url,
                targetTracker: ['archiproTracker', 'ga4Tracker'],
            });
        },
    });

    const authBanner = (
        <ArticleAuthBanner
            bannerRef={bannerRef}
            showAutModal={() => {
                showAuthModal({
                    authSource: 'articleGate',
                    skipPostSignUp: true,
                });
            }}
        />
    );

    return {
        articleGatingEnabled,
        authBanner: articleGatingEnabled ? authBanner : null,
    };
};
